// reducers/listReducer.js
import { FETCH_SYNTHESE_SUCCESS, FETCH_SYNTHESE_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  syntheseData: [],
  error: null,
  redirectToLoginPage: false,
};

const syntheseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SYNTHESE_SUCCESS:
      return {
        ...state,
        syntheseData: action.payload.syntheseData,
        error: null,
      };
    case FETCH_SYNTHESE_FAILURE:
      return {
        ...state,
        syntheseData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default syntheseReducer;
